import { Colors } from '../../../../themes/colors';
import { StyleSheet } from 'react-native';

export const stylesCropCircle = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    padding: 20,
    marginBottom: 20,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 20,
  },
  scrollviewContainer: {
    flex: 1,
    marginBottom: 20,
  },
  questionContainer: {
    backgroundColor: Colors.role.surface,
    padding: 6,
    marginBottom: 12,
  },
  instructionsContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: 24,
    marginBottom: 18,
  },
  questionTitleContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: 20,
    marginBottom: 4,
  },
});
